<style lang="scss" scoped>
.panel {
	.line-clamp {
		display: -webkit-box;
		-webkit-line-clamp: 3;
		-webkit-box-orient: vertical;  
		overflow: hidden;
	}
}
</style>

<template lang="pug">
    el-card.panel(v-if="school")
        table.data
            tr
                td Contact Email
                td 
                    p(v-for='email in school.Contact.email') {{ email || "" }}
            tr
                td Request Note
                td 
                    p(v-for='note in school.Contact.notes', class="line-clamp", :title="note") {{ note || "" }}
</template>

<script>
export default {
	props: {
		school: {
			required: true,
			type: Object
		}
	}
};
</script>
